'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = createDelegateMethods;

var _ramda = require('ramda');

function createSetMethod(model, child, method) {
  return function modelSetter() {
    var originalChild = model.get(child);

    if (originalChild) {
      var methodOnChild = originalChild[method];

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var newChild = methodOnChild.apply(originalChild, args);

      if (newChild !== originalChild) {
        return model.set(child, newChild);
      } else {
        return model;
      }
    } else {
      throw new Error('calling child method before it exists');
    }
  };
}

function createGetMethod(model, child, method, ifNotExist) {
  return function modelGetter() {
    var childModel = model.get(child);
    if (childModel) {
      var methodOnChild = childModel[method];

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return methodOnChild.apply(childModel, args);
    } else if (ifNotExist !== undefined) {
      return ifNotExist;
    } else {
      throw new Error('calling child method before it exists');
    }
  };
}

function createDelegateMethods(model, delegates) {
  (0, _ramda.forEach)(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        child = _ref2[0],
        childDelegates = _ref2[1];

    (0, _ramda.forEach)(function (_ref3) {
      var method = _ref3.method,
          as = _ref3.as,
          set = _ref3.set,
          ifNotExist = _ref3.ifNotExist;

      var methodName = as || method;

      if (set) {
        model[methodName] = createSetMethod(model, child, method);
      } else {
        model[methodName] = createGetMethod(model, child, method, ifNotExist);
      }
    }, childDelegates);
  }, (0, _ramda.toPairs)(delegates));
}